module.exports = __webpack_public_path__ + "images/emoji/japanese_castle.412716909c20cbe44535.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/japanese_castle.png
// module id = 8sm7
// module chunks = 14